module.exports = __webpack_public_path__ + "img/close.1897215b.svg";